import TextTabContent from './TextTabContent'
export default TextTabContent
